import { useTranslation } from 'libs/i18n'
import { Badge } from 'shared/atoms'
import type { BadgeVariant } from 'shared/atoms/Badge/Badge'

type PaymentStatusProps = {
	status: string | null | undefined
	prefix?: string
	dotSize?: 'sm' | 'md'
}

const VARIANTS: Record<string, BadgeVariant> = {
	success: 'success',
	paid: 'success',
	init: 'primary',
	initial: 'primary',
	requested: 'primary',
	pending: 'warning',
	processing: 'warning',
	canceled: 'danger',
	cancelled: 'danger',
	error: 'danger'
}

const IN_STORE_STATUSES = ['in_store', 'undefined']

export const PaymentStatus = ({ status, prefix, dotSize }: PaymentStatusProps) => {
	const { t } = useTranslation()
	const normalizedStatus = (status || 'in_store').toLowerCase()
	const value = IN_STORE_STATUSES.includes(normalizedStatus) ? 'in_store' : normalizedStatus
	const labels: Record<string, string> = {
		success: t('Success'),
		init: t('Init'),
		pending: t('Pending'),
		error: t('Error'),
		canceled: t('Cancelled'),
		cancelled: t('Cancelled'),
		in_store: t('In store')
	}

	return (
		<Badge
			variant={VARIANTS[value] ?? 'muted'}
			prefix={prefix}
			dotSize={dotSize}
			className="px-2.5 font-bold tracking-wide">
			{labels[value] ?? status}
		</Badge>
	)
}
